import React, { useCallback, useMemo, useState } from 'react';
import { createOptionalContext } from '../../utils/create-optional-context.js';
const [LegendsContext, LegendsContextConsumer, LegendsContextProvider, useLegends, useOptionalLegends,] = createOptionalContext('LegendsContext');
function LegendsProvider(props) {
    const [items, setItems] = useState(new Map());
    const addItem = useCallback((item) => {
        setItems(legends => {
            if (legends.has(item.value)) {
                return legends;
            }
            legends.set(item.value, {
                color: item.color,
                icon: item.icon,
                label: item.label,
                value: item.value,
            });
            return new Map(legends);
        });
    }, [setItems]);
    const getItems = useCallback(() => {
        return Array.from(items.values());
    }, [items]);
    const removeItem = useCallback((value) => {
        setItems(legends => {
            if (!legends.has(value)) {
                return legends;
            }
            legends.delete(value);
            return new Map(legends);
        });
    }, [setItems]);
    const value = useMemo(() => ({
        addItem,
        getItems,
        removeItem,
        size: props.size,
    }), [addItem, getItems, removeItem, props.size]);
    return (React.createElement(LegendsContextProvider, { value: value }, props.children));
}
export { LegendsContext, LegendsContextConsumer, LegendsProvider, useLegends, useOptionalLegends, };
//# sourceMappingURL=legends-context.js.map